import { Translate } from 'react-redux-i18n'
import { Cell, Customized } from 'recharts'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import { Element } from '../../../../../common/html/element'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Tabs } from '../../../../../common/tabs'
import { getAppendStyleItemWithCustom } from '../../../../../common/tabs/helper'
import { getNoDataComponent, getStyleHeightContainer } from '../../helper'
import classes from '../../index.module.scss'

const convertData = (data) => {
  let formatData = []
  let prev = 0

  data.forEach((item, index) => {
    const value = index === data.length - 1 ? -item.value : item.value

    const from = prev
    const to = prev + value
    prev = to

    formatData.push({
      ...item,
      formatValue: [from, to],
    })
  })

  return formatData
}

const EachYear = ({
  tabs,
  data,
  onChangeTab,
  isNoData,
  yearKey,
  isDynamicReport,
}) => {
  const { formatedUnit, formatValueWithUnit } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )

  const formatData = convertData(data)

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="flexColumn"
    >
      <Element
        style={{
          borderBottom: !isDynamicReport ? '1px solid #B5CEF8' : undefined,
        }}
        className={`dFlex justifyContentEnd ${classes.tabContainer}`}
      >
        {!isDynamicReport ? (
          <Tabs
            activeKey={yearKey}
            items={tabs}
            tabListClassName={classes.tabs}
            getAppendStyleItem={getAppendStyleItemWithCustom()}
            isScrollContent={false}
            onChange={onChangeTab}
          />
        ) : (
          <>
            {!isNoData && (
              <div className="fw600 py1 w100">
                <Translate value="common.FISCAL_YEAR" />: {yearKey}
              </div>
            )}
          </>
        )}
      </Element>
      {isNoData ? (
        getNoDataComponent(isDynamicReport)
      ) : (
        <>
          <Element className="pt1" style={{ color: '#9C9C9C' }}>
            {formatedUnit}
          </Element>
          <div className="h100">
            <ChartContainer
              data={formatData}
              width="100%"
              height="100%"
              margin={{ top: 16, left: 0, bottom: 0, right: 0 }}
              padding={{ left: 50, right: 50 }}
              xAxis={[
                {
                  dataKey: 'name',
                  height: 50,
                  lineClamp: 2,
                  tickStyle: { color: '#3A414B' },
                },
              ]}
              yAxis={[
                {
                  yAxisId: 'left',
                  dataKeys: ['formatValue'],
                  isFloatBar: true,
                  hide: true,
                },
              ]}
              tooltip={{
                schema: {
                  title: {
                    hide: true,
                  },
                  content: [
                    {
                      dataKey: 'value',
                      formatValue: (value) => formatValueWithUnit({ value }),
                    },
                  ],
                },
              }}
            >
              <Customized component={CustomElements} />
              <Bar
                yAxisId={'left'}
                dataKey={'formatValue'}
                barSize={35}
                minPointSize={1}
                isAnimationActive={false}
              >
                {formatData.map((entry, index) => {
                  return (
                    <Cell
                      key={`cell-${index}`}
                      id={`cell-${index}`}
                      fill={entry.color}
                    />
                  )
                })}
              </Bar>
            </ChartContainer>
          </div>
        </>
      )}
    </div>
  )
}

const CustomElements = (props) => {
  const { formatValue } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const data = props.data
  const bars = props.formattedGraphicalItems?.[0]?.props?.data || []

  const renderLines = () => {
    return bars
      .slice(0, -1)
      .map(({ x, y, width }, index) => (
        <line
          key={index}
          x1={x + width}
          y1={y}
          x2={bars[index + 1].x}
          y2={y}
          stroke="#ccc"
          strokeWidth={1}
        />
      ))
  }

  const renderLabels = () => {
    return bars.map(({ x, y, width, height }, index) => {
      const isLastItem = index === data.length - 1
      const isPositive = data[index].value >= 0
      const yCoordinate = isLastItem
        ? isPositive
          ? y + height - 14
          : y + height + 2
        : isPositive
        ? y - 14
        : y + 2

      return (
        <g key={index}>
          <foreignObject
            x={x - 100}
            y={yCoordinate}
            height={16}
            width={width + 200}
          >
            <Element
              style={{
                fontSize: 10,
                color: '#3A414B',
                height: '100%',
                width: '100%',
                textAlign: 'center',
              }}
            >
              {formatValue({ value: data[index].value })}
            </Element>
          </foreignObject>
        </g>
      )
    })
  }

  return (
    <>
      {renderLines()}
      {renderLabels()}
    </>
  )
}

export default EachYear
